import Interface from '../interface';

import OpenX from '@module/openx';

// This is a global var that should be defined by the
// loading of 'advertising.js' - however, if it is not
// set this means it was blocked. OH MY GLOB. So we just
// show other types of ads without measurements and stuff.
const ADS_ENABLED = !!window['__ads_enabled__'];

export default class OpenXProvider extends Interface {
  /**
   * Binds all private methods
   * @param  {Object} props Component props
   */
  constructor(props = { noAds: false }) {
    super(props);

    let noAds = false;
    if ((props.noAds && props.noAds === true) || !ADS_ENABLED) {
      // Studio/plus wallpapers
      noAds = true;
    }

    this.api = new OpenX({ noAds });
    this.identifier = noAds
      ? 'wallpaper_openx_editorial'
      : 'wallpaper_openx_ad';
  }

  get duration() {
    // How long before rotation should occur
    return this.api.getDuration();
  }

  get rotationEnabled() {
    return true;
  }

  async getMedia() {
    return await this.api.getAdvert();
  }
}
